import { InfoDocumentale, ListaAttestati } from "../../types";

// Quello che si legge quando la lista non e' arrivata: nessun attestato e
// nessun troncamento. Un guasto di rete non e' un elenco incompleto, e
// annunciarlo come tale manderebbe l'operatore a cercare attestati che ci sono.
export const LISTA_VUOTA: ListaAttestati = { attestati: [], troncata: false };

/*
 Legge l'involucro con cui il backend consegna la lista attestati.

 Tiene insieme i record e la dichiarazione `troncata` che li accompagna: il
 flag dice che l'azienda ha piu' attestati di quelli consegnati, e va letto
 nello stesso punto in cui si prendono i record, altrimenti si perde per strada
 come e' successo finche' la cosa finiva solo nei log del backend.

 Una risposta senza `ok`, senza contenuto o con un `troncata` che non e' un
 booleano vale come lista vuota e completa: si afferma il troncamento solo
 quando il backend lo afferma.

 Sta in un modulo proprio e non in utils.tsx perche' quel file importa axios:
 e' una funzione pura e deve restare testabile senza impalcatura, come
 pipeline.ts e avvisi.ts.
*/
export function leggiListaAttestati(
  risposta: InfoDocumentale | undefined | null
): ListaAttestati {
  if (!risposta || !risposta.ok || !risposta.content) return LISTA_VUOTA;
  return {
    attestati: risposta.content.data ?? [],
    troncata: risposta.content.troncata === true,
  };
}
